export default "__VITE_ASSET__Ct6hET$E__"